import GamerskyNav from './GamerskyNav.js'
import { CSS } from './css.js'

// 导出 CSS 字符串
export { CSS }

export default GamerskyNav

// 自动初始化
if (typeof window !== 'undefined') {
  window.GamerskyNav = GamerskyNav

  // 全局登录检测函数
  window.UserOnline = function(callback) {
    const nav = window.gamerskyNavInstance
    if (nav) {
      nav.UserOnline(callback)
    }
  }

  // jQuery 插件（如果 jQuery 存在）
  if (window.jQuery || window.$) {
    const jq = window.jQuery || window.$
    jq.fn.UserOnline = function(callback) {
      if (window.gamerskyNavInstance) {
        window.gamerskyNavInstance.UserOnline(callback)
      }
      return this
    }
  }

  // 自动注入样式到页面
  if (CSS && !document.getElementById('gamersky-nav-style')) {
    const style = document.createElement('style')
    style.id = 'gamersky-nav-style'
    style.textContent = CSS
    document.head.appendChild(style)
  }

  // 先保存执行当前文件的 script，避免 DOMContentLoaded 后 currentScript 丢失。
  const mountScript = document.currentScript || (function() {
    const scripts = document.getElementsByTagName('script')
    return scripts[scripts.length - 1]
  })()

  // 获取当前 script 标签并挂载到其父元素
  const autoMount = () => {
    if (mountScript && mountScript.parentElement) {
      const container = document.createElement('div')
      container.className = 'gamersky-nav-wrapper'
      mountScript.parentElement.insertBefore(container, mountScript)

      const instance = new GamerskyNav()
      instance.mount(container)
      window.gamerskyNavInstance = instance
    }
  }

  // DOM 加载完成后自动挂载
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoMount)
  } else {
    autoMount()
  }
}
